function insertUrgencyMessage() {
  const urgencyText = "⚡ Complete your order before 5 PM for same-day dispatch!";
  const existingUrgency = document.querySelector(".urgency-message");
  if (existingUrgency) return; // Avoid duplicates

  const checkoutButtons = document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout');
  checkoutButtons.forEach(button => {
    const urgency = document.createElement("p");
    urgency.textContent = urgencyText;
    urgency.className = "urgency-message";
    urgency.style.color = "#ff0000ff";
    urgency.style.fontSize = "14px";
    urgency.style.fontWeight = "600";
    urgency.style.marginBottom = "10px";
    urgency.style.textAlign = "center";
    button.parentNode.insertBefore(urgency, button);
  });
}

// Run when the page is fully loaded
document.addEventListener("DOMContentLoaded", insertUrgencyMessage);

// Also observe changes (for AJAX-loaded drawers)
const observer = new MutationObserver(insertUrgencyMessage);
observer.observe(document.body, { childList: true, subtree: true });
